<template>
  <section class="main-title-container">
    <h2>{{ title }}</h2>
    <p class="text" v-html="text"></p>
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: ['title', 'text'],
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.mobile {
  .main-title-container {
    margin-right: auto;
  }
}
.main-title-container {
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;

  h2 {
    font-size: 15px;
    font-weight: 500;
    //color: var(--sub-color);
    margin-bottom: 10px;
  }

  p {
  }

  .subtitle {
    margin-bottom: 25px;
  }

  .buttons {
    display: inline-block;
    margin-top: 20px;
    button {
      margin: 0 10px;
    }
  }
}
</style>
